module.exports = __webpack_public_path__ + "img/categories-7.4e3c80e9.jpg";